import { LatLngLiteral } from "leaflet";

/**
 * @deprecated Do not use. Instead, use LatLngLiteral
 */
export interface LorenLocation {
  latitude: number;
  longitude: number;
  time?: string;
}


export function toLatLng(location: LorenLocation | null): LatLngLiteral | null {
  if (!location) {
    return null;
  }

  if (!location.latitude && !location.longitude) {
    return null;
  }

  return { lat: location.latitude, lng: location.longitude };
}

export function toLorenLocation(location: LatLngLiteral | null): LorenLocation | null {
  if (!location) {
    return null;
  }

  return {latitude: location.lat, longitude: location.lng};
}